module.exports = __webpack_public_path__ + "static/media/adventureGame.19676831.PNG";